<template>
    <el-dialog v-model="visible" title="选择试卷" width="800px" append-to-body>
        <div class="search-bar">
            <el-input v-model="searchQuery" placeholder="搜索试卷名称" @keyup.enter="fetchPapers" clearable>
                <template #append>
                    <el-button @click="fetchPapers">
                        <el-icon>
                            <Search />
                        </el-icon>
                    </el-button>
                </template>
            </el-input>
        </div>

        <el-table :data="papers" v-loading="loading" @row-click="handleSelect" highlight-current-row
            style="margin-top: 20px; height: 400px; overflow-y: auto;">
            <el-table-column prop="name" label="试卷名称" />
            <el-table-column prop="grade" label="年级" width="100" />
            <el-table-column prop="category" label="类型" width="100" />
            <el-table-column label="创建时间" width="180">
                <template #default="scope">
                    {{ formatDate(scope.row.createdAt) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template #default="scope">
                    <el-button type="primary" link size="small">选择</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                v-model:current-page="page" @current-change="fetchPapers" />
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { Search } from '@element-plus/icons-vue'
import api from '@/utils/api'

const props = defineProps({
    modelValue: Boolean
})
const emit = defineEmits(['update:modelValue', 'select'])

const visible = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const papers = ref([])
const loading = ref(false)
const searchQuery = ref('')
const page = ref(1)
const pageSize = ref(10)
const total = ref(0)

watch(visible, (val) => {
    if (val) {
        fetchPapers()
    }
})

const fetchPapers = async () => {
    loading.value = true
    try {
        // Assume GET /api/papers supports search and pagination
        const res = await api.get('/api/papers', {
            params: {
                page: page.value,
                pageSize: pageSize.value,
                keyword: searchQuery.value
            }
        })
        papers.value = res.data.papers || []
        total.value = res.data.total || 0
    } catch (err) {
        console.error(err)
    } finally {
        loading.value = false
    }
}

const handleSelect = (row) => {
    emit('select', row)
    visible.value = false
}

const formatDate = (timestamp) => {
    if (!timestamp) return '-'
    return new Date(timestamp * 1000).toLocaleString()
}
</script>

<style scoped>
.search-bar {
    margin-bottom: 10px;
}

.pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
</style>
